import { createContext } from 'react'

const ContextLoader = createContext()
const ContextProjectIndex = createContext()

export {
	ContextLoader,
	ContextProjectIndex
}